(function() {
	"use strict";

	angular.module("sempraWebapp").component("washBayDetails", {
		templateUrl:
			"app/facilityKarcherDetails/washBayDetails/washBayDetails.html",
		controller: washBayDetails,
		bindings: {
			washFacilityData: "<"
		},
		controllerAs: "vm"
	});

	function washBayDetails() {}
})();
